<div id="pronto-pago-resultado">

  <app-card Theme="card-primary background-white">
    <div card-content>
      <app-body Theme="body-normal">
        <div body-content>

          <div class="cargando-resultado" *ngIf="cargando">
            <span class="spinner"></span>
            <app-text Theme="body-normal" Text="Cargando tu solicitud…"></app-text>
          </div>

          <div class="error-resultado" *ngIf="!cargando && error">
            <app-text Theme="body-normal"
                      Text="No pudimos cargar tu comprobante. Vuelve a intentarlo más tarde."></app-text>
            <div class="acciones-resultado">
              <app-button Theme="button-primary"
                          [Label]="'<p>Volver al inicio</p>'"
                          [IcoSvg]="null"
                          (click)="salir.emit()"></app-button>
            </div>
          </div>

          <ng-container *ngIf="!cargando && resultado">

            <!-- Encabezado de éxito -->
            <div class="cabecera-exito">
              <span class="icono-exito" aria-hidden="true">
                <svg width="38" height="38" viewBox="0 0 24 24" fill="none" stroke="#1E630D" stroke-width="2.2">
                  <path d="M20 6L9 17l-5-5"></path>
                </svg>
              </span>
              <app-text Theme="Heading2" Text="¡Acuerdo firmado con éxito!" style="color:#0078C8"></app-text>
              <p class="cabecera-exito__texto">
                Tu Acuerdo de Pronto Pago quedó suscrito. El pago se materializará el
                <b>{{ resultado.fechaMaterializacion }}</b>. Te enviamos un correo a
                <b>{{ resultado.correoNotificacion }}</b> con el Acuerdo firmado.
              </p>
            </div>

            <!-- Aviso de reflejo de pago -->
            <div class="aviso-reflejo-pago">
              El pago de las deudas que mantenías con Colmena se verá reflejado en tu sucursal virtual a partir del día <b>{{ resultado.fechaMaterializacion }}</b>.
            </div>

            <!-- Dos tarjetas: resumen + documentos -->
            <div class="resultado-grid">

              <!-- Resumen de lo aceptado -->
              <div class="tarjeta">
                <h3 class="tarjeta__titulo">Resumen de lo aceptado</h3>
                <div class="fila">
                  <span class="fila__label">Folio</span>
                  <span class="fila__valor">{{ resultado.folio }}</span>
                </div>
                <div class="fila">
                  <span class="fila__label">Acreedor</span>
                  <span class="fila__valor">{{ resultado.acreedor }}</span>
                </div>
                <div class="fila">
                  <span class="fila__label">Deuda pendiente de pago</span>
                  <span class="fila__valor">$ {{ resultado.montoTotalPesos | number:'1.0-0' }}</span>
                </div>
                <div class="fila" *ngIf="resultado.compensando">
                  <span class="fila__label">Compensación de deuda</span>
                  <span class="fila__valor fila__valor--descuento">− $ {{ resultado.deudaCompensarPesos | number:'1.0-0' }}</span>
                </div>
                <div class="fila" *ngIf="!resultado.compensando">
                  <span class="fila__label">Descuento por pago anticipado</span>
                  <span class="fila__valor fila__valor--descuento">− $ {{ resultado.montoTotalDescuentoSinCompensacionClp | number:'1.0-0' }}</span>
                </div>
                <div class="fila" *ngIf="resultado.compensando">
                  <span class="fila__label">Descuento por pago anticipado</span>
                  <span class="fila__valor fila__valor--descuento">− $ {{ resultado.montoTotalDescuentoConCompensacionClp | number:'1.0-0' }}</span>
                </div>
                <div class="fila" *ngIf="!resultado.compensando">
                  <span class="fila__label">Monto a recibir</span>
                  <span class="fila__valor fila__valor--liquido">$ {{ resultado.liquidoSinCompensacionPesos | number:'1.0-0' }}</span>
                </div>
                <div class="fila" *ngIf="resultado.compensando">
                  <span class="fila__label">Monto a recibir</span>
                  <span class="fila__valor fila__valor--liquido">$ {{ resultado.liquidoConCompensacionPesos | number:'1.0-0' }}</span>
                </div>
                <div class="fila">
                  <span class="fila__label">Estado</span>
                  <span class="fila__valor"><span class="badge-estado">{{ resultado.estado }}</span></span>
                </div>
              </div>

              <!-- Tus documentos -->
              <div class="tarjeta tarjeta--docs">
                <h3 class="tarjeta__titulo">Tus documentos</h3>
                <p class="tarjeta__intro">
                  Descarga aquí tu Acuerdo de Pronto Pago firmado
                </p>
                <div class="docs">
                  <!-- d.url = URL firmada de GCS; se abre en pestaña nueva (navegación directa, sin XHR/CORS). -->
                  <div class="doc" *ngFor="let d of resultado.documentos">
                    <span class="doc__nombre">
                      <span class="doc__badge">PDF</span>{{ d.titulo }}
                    </span>
                    <a class="doc__descargar" (click)="descargarDocumento(d)">
                      <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8">
                        <path d="M12 3v12"></path><path d="M7 10l5 5 5-5"></path><path d="M5 21h14"></path>
                      </svg>
                      Descargar
                    </a>
                  </div>
                </div>
              </div>

            </div>

            <!-- Aviso de seguimiento -->
            <div class="aviso-seguimiento">
              El pago se realizará utilizando el medio de pago registrado en nuestros sistemas.
              Si cuentas con una cuenta bancaria vigente registrada, el pago se efectuará mediante
              transferencia electrónica. Si no existe una cuenta bancaria registrada o la
              transferencia es rechazada por la institución financiera, el pago se realizará mediante
              vale vista. Una vez ejecutado el pago, recibirás un correo electrónico de confirmación
              indicando el resultado de la operación y el medio de pago.
            </div>

            <!-- CTAs -->
            <div class="acciones-resultado">
              <app-button Theme="button-primary"
                          [Label]="'<p>Volver al inicio</p>'"
                          [IcoSvg]="null"
                          (click)="salir.emit()"></app-button>
            </div>

          </ng-container>

        </div>
      </app-body>
    </div>
  </app-card>
</div>
